import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';

import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { AboutDialogComponent } from './about-dialog.component';

@Component({
  templateUrl: './toolbar-content.component.html',
  styleUrls: ['./toolbar-content.component.scss'],
  imports: [CommonModule, MatDialogModule, MatIconModule, MatMenuModule],
})
export class ToolbarContentComponent {
  protected small = true;

  constructor(
    public readonly titleService: Title,
    private readonly dialog: MatDialog,
    private readonly breakpointObserver: BreakpointObserver
  ) {}

  public ngOnInit() {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.small = true;
      } else {
        this.small = false;
      }
    });
  }

  protected about() {
    this.dialog.open(AboutDialogComponent, { disableClose: true });
  }
}
